export default __webpack_public_path__ + "static/media/successImg.fcf71168.svg";